import React, { Fragment } from 'react'

/** Calendar Dates Info component to display information when arrival and departure dates are selected */
const CalendarDatesInfo = (props) => {
    return (
        <div className={'calendar_info'}>
            <div className="calendar_info_label">
                <strong>{props.selectedDate}</strong>
            </div>
            <div className="calendar_info_buttons">
                <input type="button" value={props.buttonReset} className="cancel_button" onClick={props.onResetDatePickerDates} />
                <input type="button" value={props.buttonDone} className="button" onClick={props.onCloseDatePicker} />
            </div>
        </div>
    )
}

export default CalendarDatesInfo
